/* RedirectLink.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import React from 'react';
import { Link } from '../../Links';
const _2 = "._k48p1nn1{font-weight:400}";
const _ = "._vwz41tcg{line-height:24px}";
export const RedirectStyled = forwardRef((_ref, __cmplr) => {
  let {
      as: C = Link,
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_vwz41tcg _k48p1nn1", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  RedirectStyled.displayName = 'RedirectStyled';
}
export const RedirectLink = props => {
  return /*#__PURE__*/React.createElement(RedirectStyled, _extends({
    size: "medium",
    rel: "noopener noreferrer"
  }, props), props.children);
};